const PENDING_REDIRECT_KEY = 'pendingRedirect';
const CONSUMED_KEY = 'pendingRedirectConsumed';
const CONSENT_RETURN_KEY = 'consentReturn';
const CONSENT_PATH = '/hive/partners/consent';

export const getPendingRedirect = (): string | null => {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage.getItem(PENDING_REDIRECT_KEY);
  } catch {
    return null;
  }
};

export const setPendingRedirect = (route: string | null): void => {
  if (typeof window === 'undefined') return;
  try {
    if (route) window.sessionStorage.setItem(PENDING_REDIRECT_KEY, route);
    else window.sessionStorage.removeItem(PENDING_REDIRECT_KEY);
    window.sessionStorage.removeItem(CONSUMED_KEY);
  } catch {}
};

export const clearPendingRedirect = (): void => setPendingRedirect(null);

export const markPendingRedirectConsumed = (): void => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(CONSUMED_KEY, 'true');
  } catch {}
};

export const isPendingRedirectConsumed = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return window.sessionStorage.getItem(CONSUMED_KEY) === 'true';
  } catch {
    return false;
  }
};

const BASE_PATH = '/uk';

const NON_PARKABLE_PREFIXES = ['/hive/accounts/', '/hive/beehive-loading'];

export const toParkableRoute = (path: string | undefined): string | null => {
  if (!path || !path.startsWith('/') || path.startsWith('//')) return null;

  const route = path.startsWith(`${BASE_PATH}/`)
    ? path.slice(BASE_PATH.length)
    : path;

  const [pathname] = route.split(/[?#]/);

  if (!pathname.startsWith('/hive/')) return null;
  if (NON_PARKABLE_PREFIXES.some((prefix) => pathname.startsWith(prefix)))
    return null;

  return route;
};

export const toConsentReturnRoute = (
  path: string | null | undefined,
): string | null => {
  const route = toParkableRoute(path ?? undefined);
  if (!route) return null;

  const [pathname] = route.split(/[?#]/);

  return pathname === CONSENT_PATH ? route : null;
};

export const getConsentReturn = (): string | null => {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage.getItem(CONSENT_RETURN_KEY);
  } catch {
    return null;
  }
};

export const setConsentReturn = (route: string | null): void => {
  if (typeof window === 'undefined') return;
  try {
    if (route) window.sessionStorage.setItem(CONSENT_RETURN_KEY, route);
    else window.sessionStorage.removeItem(CONSENT_RETURN_KEY);
  } catch {}
};

export const clearConsentReturn = (): void => setConsentReturn(null);

export const takeConsentReturn = (): string | null => {
  const route = getConsentReturn();
  if (route) clearConsentReturn();
  return route;
};
